import React, { useState } from 'react';
import { getBrandName } from '../getBrandName';

export const usePrivacyLogic = () => {
  const [active, setActive] = useState("collection");
  const { brandName , normalizedBrand } = getBrandName();
  const sections = [
    { id: "collection", title: "1. Information We Collect" },
    // { id: "purpose", title: "2. Why We Collect Your Data" },
    { id: "usage", title: "2. How We Use Your Information" },
    { id: "amazon", title: "3. AMAZON-SPECIFIC DATA PROTECTION COMMITMENTS" },
    { id: "sharing", title: "4. Data Sharing & Disclosure" },
    { id: "safety", title: "5. DATA SECURITY AND PROTECTION" },
    { id: "retention", title: "6. DATA RETENTION AND DELETION" },
    { id: "choices", title: "7. Your Rights and Choices" },
    { id: "transfer", title: "8. INTERNATIONAL DATA TRANSFERS" },
    { id: "children", title: "9. CHILDREN'S PRIVACY" },
    { id: "california", title: "10. CALIFORNIA PRIVACY RIGHTS (CCPA)" },
    { id: "europ", title: "11. EUROPEAN PRIVACY RIGHTS (GDPR)" },
    { id: "updates", title: "12. Policy Updates" },
    { id: "contact", title: "13. CONTACT INFORMATION" },
    { id: "certificate", title: "14. AMAZON COMPLIANCE CERTIFICATION" },
  ];

  const handleScrollTo = (id) => {
    setActive(id);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const generateContent = (id) => {
    const content = {
      collection: {
        list: [
          {
            heading: "1.1 Personal Information",
            text: "We may collect the following personal information:",
            items: [
              "Email address",
              "Phone number",
              "Name and business contact information",
              "Company name and business registration details",
              "Payment and billing information (processed securely through third-party processors)"
            ],
          },
          {
            heading: "1.2 Amazon Seller Data",
            text:"When you authorize Gapalyz to access your Amazon seller account through the Amazon Selling Partner API (SP-API), we collect:",
            items: [
              "Sales performance data (orders, revenue, units sold)",
              "Advertising performance metrics (campaign data, keywords, ad spend)",
              "Product catalog information (ASINs, product details, pricing)",
              "Inventory and fulfillment data",
              "Geographic sales distribution data (region, state, city performance)",
              "Business reports and analytics data",
              "Brand Analytics data (when available and authorized)"
            ],
            note:"Important Note: We access Amazon data solely through official Amazon APIs with your explicit authorization. We do not use any non-Amazon resources or external data services to obtain Amazon seller information, in full compliance with Amazon's AUP Section 4.3."
          },
          {
            heading: "1.3 Usage and Technical Data",
            items: [
              "IP address and geolocation data",
              "Browser type, version, and device information",
              "Pages visited, time spent, and referring URLs",
              "Login credentials (secured and encrypted)",
              "User preferences and interaction history",
              "Application performance metrics"
            ],
          },
                  {
            heading: "1.4 Cookies and Tracking Technologies",
            items: [
              "We use cookies and similar technologies to enhance your experience, analyze usage patterns, and improve our services."
            ],
          },
        ],
      },
      usage: {
        
        list: [
          {
            heading: "2.1 Service Provision",
            text: "We use your data to:",
            items: [
              "Provide Amazon seller analytics and insights",
              "Generate dashboards and performance reports",
              "Deliver actionable business intelligence and recommendations",
              "Create geographic and temporal performance analysis",
              "Provide product and category-specific insights",
              "Enable KPI tracking and business monitoring"
            ],
          },
           {
            heading: "2.2 Account Management",
            text: "",
            items: [
              "Set up and manage user accounts",
              "Authenticate users and prevent unauthorized access",
              "Provide customer support and technical assistance",
              "Process billing and subscription management"
            ],
          },
          {
            heading: "2.3 Service Improvement",
            text: "",
            items: [
              "Analyze usage trends to improve system performance",
              "Develop new features and analytical capabilities",
              "Monitor and optimize application performance",
              "Conduct research and development for better insights"
            ],
          },
          {
            heading: "2.4 Communication",
            text: "",
            items: [
              "Send service-related notifications and updates",
              "Provide customer support responses",
              "Share product enhancements and new features"
            ],
          },
          {
            heading: "2.5 Legal and Compliance",
            text: "",
            items: [
              "Fulfill applicable legal obligations",
              "Detect, prevent, and address technical issues, abuse, or fraud",
              "Comply with Amazon's policies and requirements",
              "Respond to legal requests and prevent illegal activities"
            ],
          }
        ]
      },
      amazon: {
        
        list: [
          {
            heading: "3.1 Compliance with Amazon Policies",
            text: "Gapalyze strictly complies with:",
            items: [
              "Amazon's Acceptable Use Policy (AUP)",
              "Amazon's Data Protection Policy (DPP)",
              "Amazon Services API Developer Agreement",
              "All applicable Amazon seller program policies",
            ],
          },
           {
            heading: "3.2 Prohibited Data Uses (AUP Compliance)",
            text: "We explicitly commit that we will NEVER:",
            items: [
              "Aggregate data across different Amazon sellers' businesses (AUP 4.4)",
              "Sell or provide seller data to third parties, including competitors (AUP 4.4)",
              "Use Amazon seller data for non-Amazon business purposes (AUP 4.5)",
              "Promote, publish, or share insights about Amazon's business (AUP 4.5)",
              "Target Amazon customers for marketing or review manipulation (AUP 4.2)",
              "Use external (non-Amazon) data services for Amazon-related insights (AUP 4.3)",
              "Deceive users through modification of Amazon-provided information (AUP 2.3)"
            ],
          },
          {
            heading: "3.3 Data Segregation",
            text: "",
            items: [
              "Each seller's data is kept completely separate and isolated",
              "No cross-seller analysis or data sharing occurs",
              "All insights are generated exclusively for the individual seller who authorized access",
              "Data access follows strict 'need-to-know' principles within our organization"
            ],
          },
          {
            heading: "3.4 Authorized Use Only",
            text: "We only access and use Amazon seller data for:",
            items: [
              "Providing authorized analytics services to the specific seller",
              "Generating insights and reports exclusively for that seller",
              "Supporting legitimate business activities as requested by the seller",
              "Meeting legal and tax requirements when necessary"
            ],
          }
        ]
      },
      sharing: {
        list: [
          {
            heading: "4.1 No Sale or Rent of Data",
            text: "We do not sell or rent your personal information or Amazon seller data to anyone.",
            items: [
              "We do not sell or rent your personal information or Amazon seller data to anyone.",
            ],
          },
           {
            heading: "4.2 Limited Sharing",
            text: "We may share your information only in the following circumstances:",
            items: [
              "Service Providers: Trusted third-party service providers who support our operations under strict data protection agreements, including:",
              "Cloud hosting and infrastructure providers",
              "Customer support platforms",
              "Payment processors",
              "Security and monitoring services",
              "Legal Requirements: When required by law, regulation, or legal process, including:",
              "Compliance with court orders or subpoenas",
              "Cooperation with law enforcement investigations",
              "Meeting tax and regulatory reporting requirements",
              "Protecting our legal rights and interests",
              "Business Transfers: In the event of a merger, acquisition, or sale of business assets, with advance notice and continued data protection commitments"
            ],
          },
          {
                heading: "4.3 Amazon Data Sharing Restrictions",
                text: "Amazon seller data is never shared with:",
                items: [
                  "Other sellers or competitors",
                  "Marketing companies or advertisers",
                  "Data brokers or analytics companies",
                  "Any party not directly involved in providing services to you",
                  "Affiliated entities without your explicit consent"
                ],
              },
              {
                heading: "4.4 Restrictions with Aggregators",
                text: "We do not aggregate data across Authorized Users' businesses or Customers obtained through the Amazon Services API to provide or sell to any parties, including competing Authorized Users.",
                items: [],
              },
              {
                heading: "4.5 Amazon Business Data Restriction",
                text: "We do not promote, publish, or share insights about Amazon's business. Do not use insights about Amazon's business for your own business purposes.",
                items: [],
              }
        ]
      },
      safety: {
          list: [
              {
                heading: "5.1 Technical Safeguards",
                text: "We implement industry-leading security measures:",
                items: [
                  "Encryption:",
                  "TLS 1.3 for all data in transit",
                  "AES-256 encryption for all data at rest",
                  "End-to-end encryption for sensitive communications",
                  "Secure key management and rotation",
                  "Access Controls:",
                  "Multi-factor authentication for all accounts",
                  "Role-based access with the principle of least privilege",
                  "Regular access reviews and account deactivation",
                  "Unique user IDs and no shared accounts",
                  "Network Security:",
                  "Web Application Firewall (WAF) protection",
                  "Network segmentation and access control lists",
                  "Regular security monitoring and intrusion detection",
                  "Anti-virus and anti-malware protection"
                ],
              },
              {
                heading: "5.2 Operational Security",
                text: "",
                items: [
                  "Personnel Security:",
                  "Background checks for employees with data access",
                  "Regular security training and awareness programs",
                  "Confidentiality agreements and data handling policies",
                  "Quarterly access reviews and privilege audits",
                  "Infrastructure Security:",
                  "Secure cloud hosting with certified providers",
                  "Regular security assessments and penetration testing",
                  "Vulnerability management and patch procedures",
                  "Business continuity and disaster recovery plans"
                ],
              },
              {
                heading: "5.3 Incident Response",
                text: "We maintain comprehensive incident response procedures:",
                items: [
                  "24-hour notification to Amazon for security incidents",
                  "Detailed incident investigation and documentation",
                  "Immediate containment and remediation actions",
                  "Post-incident analysis and prevention measures"
                ],
              }
            ]     
      },
      retention: {
          list: [
            {
              heading: "6.1 General Data Retention",
              text: "We retain your data only as long as necessary to:",
              items: [
                "Provide our services and support your account",
                "Meet legal and regulatory requirements",
                "Resolve disputes and enforce agreements",
                "Maintain business records as required by law"
              ],
            },
            {
              heading: "6.2 Amazon Seller Data Retention",
              text: "Amazon seller data is retained for:",
              items: [
                "Active accounts: As long as your subscription is active and you require our services",
                "Inactive accounts: Up to 90 days after service termination for transition support",
                "Legal requirements: Minimal data for tax and regulatory compliance only"
              ],
            },
            {
              heading: "6.3 Secure Deletion",
              text: "When data is deleted:",
              items: [
                "Secure deletion follows NIST 800-88 standards",
                "Complete removal from all systems within 72 hours of deletion request",
                "The verification process ensures that the data is irretrievably destroyed",
                "Certification available upon request"
              ],
            }
          ]   
      },
      choices: {
        list: [
          {
            heading: "7.1 Access and Control",
            text: "You have the right to:",
            items: [
              "Access all personal and business data we hold about you",
              "Correct inaccurate or incomplete information",
              "Delete your account and associated data",
              "Export your data in a portable format",
              "Restrict certain data processing activities"
            ],
          },
          {
            heading: "7.2 Amazon Authorization Management",
            text: "You can:",
            items: [
              "Revoke Amazon API access at any time through Amazon Seller Central",
              "Monitor app permissions in your Amazon seller account",
              "Control data sharing through granular permission settings",
              "Request immediate data deletion upon authorization revocation"
            ],
          },
          {
            heading: "7.3 Communication Preferences",
            text: "",
            items: [
              "Opt out of promotional emails via unsubscribe links",
              "Manage notification preferences in your account settings",
              "Choose communication channels and frequency",
              "Update contact information and preferences"
            ],
          },
          {
            heading: "7.4 Cookie Management",
            text: "",
            items: [
              "Control cookies through browser settings",
              "Opt out of non-essential tracking",
              "Customize your privacy preferences",
              "Review our cookie usage and purposes"
            ],
          }
        ]
      },
      transfer: {
        list: [
          {
            heading: "8.1 Data Processing Locations",
            text: "Your data may be processed in:",
            items: [
              "United States: Primary data processing and analytics",
              "European Union: EU customer data remains within EU boundaries",
              "Other regions: As required to serve your geographic location"
            ],
          },
          {
            heading: "8.2 Transfer Safeguards",
            text: "When transferring data internationally, we ensure:",
            items: [
              "Adequacy decisions where available",
              "Standard Contractual Clauses for EU data transfers",
              "Data Processing Agreements with all service providers",
              "Continuous monitoring of transfer regulations and compliance"
            ],
          }
        ]
      },
      children: {
        text: "Gapalyze is designed for business use and is not intended for individuals under 18 years of age. We do not knowingly collect personal information from children under 18. If we become aware that we have collected such information, we will promptly delete it.",
      },
      california: {
        text: "California residents have additional rights under the California Consumer Privacy Act:",
        list: [
          "Right to know what personal information we collect and how it's used",
          "Right to delete personal information (subject to legal exceptions)",
          "Right to opt-out of the sale of personal information (we don't sell data)",
          "Right to non-discrimination for exercising privacy rights",
          "To exercise these rights, contact us at privacy@gapalyze.com."
        ],
      },
      europ: {
        text: "If you are in the European Economic Area, you have rights under the General Data Protection Regulation:",
        list: [
          "Legal basis: We process data based on legitimate interests, contract performance, or consent",
          "Data portability: Right to receive your data in a structured format",
          "Right to object: To processing based on legitimate interests",
          "Supervisory authority: Right to file complaints with data protection authorities",
        ],
      },
      updates: {
        list: [
            {
              heading: "12.1 Notification of Changes",
              text: "We may update this Privacy Policy periodically to reflect:",
              items: [
                "Changes in our services or practices",
                "New legal or regulatory requirements",
                "Amazon policy updates",
                "Enhanced security measures"
              ],
            },
            {
              heading: "12.2 Communication of Changes",
              text: "When we update this policy:",
              items: [
                "Email notification to all active users",
                "Prominent notice on our website and application",
                "30-day advance notice for material changes",
                "Opportunity to review and object to significant changes"
              ],
            },
            {
              heading: "12.3 Version History",
              text: "",
              items: [
                "We maintain a history of policy versions",
                "Previous versions available upon request",
                "Clear indication of changes in new versions",
                "Effective date clearly displayed"
              ],
            }
          ]
      },
      contact: {
        list: [
          {
            heading: "13.1 Privacy Questions and Requests",
            text: "For privacy-related questions, requests, or concerns:",
            items: [
              "Email: privacy@gapalyze.com",
              "Phone: +91-94248-47009",
              "Address: [Insert Physical Address]",
              "Response Time: Within 72 hours for all privacy requests"
            ],
          },
          {
            heading: "13.2 Data Protection Officer",
            text: "Our Data Protection Officer can be reached at:",
            items: [
              "Email: dpo@gapalyze.com",
              "Specialty: GDPR compliance and data protection matters"
            ],
          },
          {
            heading: "13.3 Security Incident Reporting",
            text: "For security concerns or suspected incidents:",
            items: [
              "Email: security@gapalyze.com",
              "Emergency Contact: [24/7 Security Hotline]",
              "Response Time: Immediate acknowledgment, 24-hour investigation"
            ],
          }
        ]
      },
      certificate: {
        list: [
          {
            heading: " ",
            text: "Gapalyze certifies that:",
            items: [
              "All Amazon seller data is used exclusively for authorized purposes",
              "We maintain compliance with Amazon's current and future policy requirements",
              "Our security measures meet or exceed Amazon's standards",
              "We cooperate fully with Amazon's audit and compliance processes",
              "We notify Amazon immediately of any compliance issues or security incidents",
              "This Privacy Policy demonstrates our commitment to protecting your data while enabling powerful Amazon seller analytics and insights through Gapalyze  's authorized services"
            ],
          }
        ]     
      },

    //  purpose: {
    //     text: "We collect and use your data to:",
    //     list: [
    //       "Set up and manage your own account",
    //       "Provide access to sales analytics tools and dashboards",
    //       "Personalize your user experience",
    //       "Respond to customer service requests and inquiries",
    //       "Notify you about updates, product enhancements, or new features",
    //       "Monitor and analyze usage trends to improve system performance",
    //       "Detect, prevent, and address technical issues, abuse, or fraud",
    //       "Fulfill any applicable legal obligations",
    //     ],
    //   },

    };

    const section = content[id];

    return (
      <div>
        {section.text && <p>{section.text}</p>}

        {/* Handle nested list for 'collection' section */}
{Array.isArray(section.list) && section.list.length > 0 && (
  <>
    {/* Case 1: Object-based structured list */}
    {typeof section.list[0] === "object" && section.list[0]?.heading ? (
      <ul className='text-break' style={{ paddingLeft: "1.2rem", listStyleType: "disc" }}>
        {section.list.map((item, i) => (
          <li key={i} style={{ marginBottom: "0.5rem" }}>
            <strong>{item.heading}</strong>

            {/* Optional description text */}
            {item.text && (
              <p style={{ margin: "0.3rem 0 0.4rem 0" }}>{item.text}</p>
            )}

            {/* Sub-items (if any) */}
            {Array.isArray(item.items) && item.items.length > 0 && (
              <ul style={{ paddingLeft: "1.2rem", listStyleType: "circle" }}>
                {item.items.map((subItem, j) => (
                  <li key={j}>{subItem}</li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    ) : (
      // Case 2: Flat list (array of strings)
      <ul className='text-break' style={{ paddingLeft: "1.2rem", listStyleType: "disc" }}>
        {section.list.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    )}
  </>
)}


        {section.footer && <p>{section.footer}</p>}
      </div>
    );
  };

  return { sections, active, handleScrollTo, generateContent };
};
